module.exports = __webpack_public_path__ + "static/media/bigpic-keyvisualbg.11528d98.jpg";